import { createAction, props } from '@ngrx/store';

import { Company, Manager } from '@shared/models';
import { AssociationModule } from '@shared/services';

export const companiesGet = createAction('[Companies] Get', props<{ id: number }>());

export const companiesGetSuccess = createAction('[Companies] Get Success', props<{ company: Company }>());

export const companiesGetFail = createAction('[Companies] Get Fail', props<{ error: any }>());

export const companiesLoad = createAction('[Companies] Load', props<{ companies?: any }>());

export const companiesLoadSuccess = createAction('[Companies] Load Success', props<{ companies?: Company[] }>());

export const companiesLoadFail = createAction('[Companies] Load Fail', props<{ error?: any }>());

export const companiesCreate = createAction('[Companies] Create', props<{ company: Partial<Company>; photo?: File }>());

export const companiesCreateSuccess = createAction('[Companies] Create Success', props<{ company: Company }>());

export const companiesCreateFail = createAction('[Companies] Create Fail', props<{ error: any }>());

export const companiesUpdate = createAction('[Companies] Update', props<{ company: Company }>());

export const companiesUpdateSuccess = createAction('[Companies] Update Success', props<{ company: Company }>());

export const companiesUpdateFail = createAction('[Companies] Update Fail', props<{ error: any }>());

export const companyObjectSavePhoto = createAction(
  '[Companies] Photo Save',
  props<{ company?: Company; manager?: Manager; photo: File; associationModule: AssociationModule }>(),
);

export const companyObjectUpdateWithPhoto = createAction(
  '[Companies] Update company photo',
  props<{ company?: Company; manager?: Manager; photo: File; associationModule: AssociationModule }>(),
);

export const companiesCreateWithPhoto = createAction('[Companies] Create with photo', props<{ company: Company }>());

export const companiesSelect = createAction('[Companies] Select', props<{ id: number }>());
